/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import { useLocation } from 'js/lib/useRouter';

import { Button, typography2 } from '@coursera/cds-core';
import type { PageTabName } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

export type Props = {
  trackingName?: PageTabName;
  label?: string;
  href?: string;
  name?: string;
};

const styles = {
  link: css`
    &.isCurrent {
      color: var(--cds-color-interactive-primary-hover);
    }

    ${typography2.bodySecondary}
    color: var(--cds-color-neutral-primary-weak);

    :hover,
    :focus,
    :active {
      background-color: var(--cds-color-interactive-background-primary-hover-weak);
      text-decoration: none;
      color: var(--cds-color-interactive-primary-hover);
    }
  `,
};

const MyLearningGridItem = ({ label, href, name, trackingName }: Props) => {
  const track = useTracker();
  const location = useLocation();
  const isCurrent = location.pathname.split('/').pop() === 'my-learning';

  return (
    <Button
      href={href}
      variant="ghost"
      css={[styles.link]}
      data-testid={`nav-link-grid-item-${name ?? href}`}
      onClick={() => {
        track('click_page_tab', { pageTab: { name: trackingName } });
      }}
      component={Link}
      size="small"
      className={isCurrent ? 'isCurrent' : undefined}
    >
      {label}
    </Button>
  );
};

export default MyLearningGridItem;
